export const Events = Object.freeze({
  CART_UPDATED: 'scale:cart:updated',
  CART_ERROR: 'scale:cart:error',
  VARIANT_SELECTED: 'scale:variant:selected',
  PRODUCT_ADDED: 'scale:product:added',
  MODAL_OPEN: 'scale:modal:open',
  MODAL_CLOSE: 'scale:modal:close',
  DRAWER_OPEN: 'scale:drawer:open',
  DRAWER_CLOSE: 'scale:drawer:close',
  SECTION_REFRESH: 'scale:section:refresh',
  TOAST: 'scale:toast',
  FORM_UPDATED: 'scale:form:updated',
  QUANTITY_BREAKS_UPDATED: 'scale:quantity-breaks:updated',
  SUBSCRIPTION_UPDATED: 'scale:subscription:updated',
  FILTERS_UPDATED: 'scale:filters:updated',
});

export class CartUpdatedEvent extends Event {
  constructor(cart, { source, sections } = {}) {
    super(Events.CART_UPDATED, { bubbles: true });
    this.cart = cart;
    this.source = source;
    this.sections = sections;
  }
}

export class CartErrorEvent extends Event {
  constructor(error) {
    super(Events.CART_ERROR, { bubbles: true });
    this.error = error;
  }
}

export class VariantSelectedEvent extends Event {
  constructor(variant) {
    super(Events.VARIANT_SELECTED, { bubbles: true });
    this.variant = variant;
  }
}

export class ProductAddedEvent extends Event {
  constructor(product, quantity) {
    super(Events.PRODUCT_ADDED, { bubbles: true });
    this.product = product;
    this.quantity = quantity;
  }
}

export class ModalOpenEvent extends Event {
  constructor(id) {
    super(Events.MODAL_OPEN, { bubbles: true });
    this.modalId = id;
  }
}

export class ModalCloseEvent extends Event {
  constructor(id) {
    super(Events.MODAL_CLOSE, { bubbles: true });
    this.modalId = id;
  }
}

export class DrawerOpenEvent extends Event {
  constructor(id) {
    super(Events.DRAWER_OPEN, { bubbles: true });
    this.drawerId = id;
  }
}

export class DrawerCloseEvent extends Event {
  constructor(id) {
    super(Events.DRAWER_CLOSE, { bubbles: true });
    this.drawerId = id;
  }
}

export class SectionRefreshEvent extends Event {
  constructor(sectionId) {
    super(Events.SECTION_REFRESH, { bubbles: true });
    this.sectionId = sectionId;
  }
}

export class ToastEvent extends Event {
  constructor(message, { type = 'info', duration = 4000 } = {}) {
    super(Events.TOAST, { bubbles: true });
    this.message = message;
    this.toastType = type;
    this.duration = duration;
  }
}

export class FormUpdatedEvent extends Event {
  constructor(formId, data) {
    super(Events.FORM_UPDATED, { bubbles: true });
    this.formId = formId;
    this.data = data;
  }
}

export class QuantityBreaksUpdatedEvent extends Event {
  constructor(variantId, breaks) {
    super(Events.QUANTITY_BREAKS_UPDATED, { bubbles: true });
    this.variantId = variantId;
    this.breaks = breaks;
  }
}

export class SubscriptionUpdatedEvent extends Event {
  constructor(sellingPlan) {
    super(Events.SUBSCRIPTION_UPDATED, { bubbles: true });
    this.sellingPlan = sellingPlan;
  }
}

export class FiltersUpdatedEvent extends Event {
  constructor(url) {
    super(Events.FILTERS_UPDATED, { bubbles: true });
    this.url = url;
  }
}
